var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCompletelyNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1050",
    "data-name": "Rectangle 1050",
    width: 35,
    height: 35,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_completely_new",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(337.01 223.595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_183-2",
    "data-name": "Group 183",
    transform: "translate(-0.177 -0.173)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21758",
    "data-name": "Path 21758",
    d: "M16.308,32.071A15.764,15.764,0,1,1,32.073,16.306,15.782,15.782,0,0,1,16.308,32.071",
    transform: "translate(1.346 1.345)",
    fill: "#ffcc54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21759",
    "data-name": "Path 21759",
    d: "M2.67,18.435A15.75,15.75,0,0,1,28.383,6.221,15.755,15.755,0,1,0,6.218,28.383,15.682,15.682,0,0,1,2.67,18.435",
    transform: "translate(1.046 1.043)",
    fill: "#ffe8b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21760",
    "data-name": "Path 21760",
    d: "M17.477,0A17.477,17.477,0,1,0,34.954,17.477,17.5,17.5,0,0,0,17.477,0m0,33.243A15.764,15.764,0,1,1,33.243,17.477,15.784,15.784,0,0,1,17.477,33.243",
    transform: "translate(0.177 0.174)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21761",
    "data-name": "Path 21761",
    d: "M6.038,4.943a2.443,2.443,0,0,1,1.645.641,1.934,1.934,0,1,0,2.541,1.831,2.073,2.073,0,0,0-.041-.4,4.173,4.173,0,0,0-8.328.4.856.856,0,1,0,1.711,0A2.474,2.474,0,0,1,6.038,4.943",
    transform: "translate(4.178 7.145)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21762",
    "data-name": "Path 21762",
    d: "M10.478,3.232A4.186,4.186,0,0,0,6.295,7.415a.856.856,0,1,0,1.711,0,2.476,2.476,0,0,1,2.472-2.472,2.443,2.443,0,0,1,1.645.641,1.934,1.934,0,1,0,2.541,1.831,2.073,2.073,0,0,0-.041-.4,4.176,4.176,0,0,0-4.145-3.785",
    transform: "translate(13.755 7.145)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21763",
    "data-name": "Path 21763",
    d: "M12.42,6.5a12.023,12.023,0,0,0-9.925,5.244.855.855,0,1,0,1.411.966,10.306,10.306,0,0,1,17.029,0,.856.856,0,1,0,1.414-.966A12.032,12.032,0,0,0,12.42,6.5",
    transform: "translate(5.234 14.183)",
    fill: "#404040"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCompletelyNew);
export default __webpack_public_path__ + "static/media/ic_completely_new.a0ac56ef3c98f4806f1eb4b5c6f47786.svg";
export { ForwardRef as ReactComponent };